enum BillingInterval {
  MONTH = "month",
  YEAR = "year",
  AD_HOC = "ad_hoc",
}

// eslint-disable-next-line no-redeclare
namespace BillingInterval {
  export const names = {
    [BillingInterval.MONTH]: "/month",
    [BillingInterval.YEAR]: "/year",
    [BillingInterval.AD_HOC]: " one-off",
  } as any;

  export const typeName = {
    [BillingInterval.MONTH]: "Monthly",
    [BillingInterval.YEAR]: "Yearly",
    [BillingInterval.AD_HOC]: "One-off",
  } as any;

  export const display = (cycle: BillingInterval) => {
    return names[cycle];
  };

  export const displayType = (cycle: BillingInterval) => {
    return typeName[cycle];
  };

  export const defaultValue = BillingInterval.MONTH;
}

export { BillingInterval };
